import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { propTypes as reduxFormPropTypes, reduxForm } from 'redux-form';
import SaveSelectionForm from '../../../wizard/common/components/SaveSelectionForm';

const field = 'selectionName';

const isFieldUnique = (values, props) => {
  let isUnique = true;

  if (props.currentReport && props.currentReport.saved && props.currentReport.saved.length) {
    isUnique = props.currentReport.saved.some(saved =>
      saved[field] &&
      values[field] &&
      (saved[field].toLowerCase() === values[field].toLowerCase())) === false;
  }

  return isUnique;
};

const validate = (values, props) => {
  const errors = {};
  const maxLength = 255;
  const value = values[field];

  if (!value) {
    errors[field] = (
      <div id="mandatory">
        <FormattedMessage id={`app.field.mandatory.${field}`} />
      </div>
    );
  } else if (!value.trim()) {
    errors[field] = (
      <div id="not-blank">
        <FormattedMessage id={`app.field.not.blank.${field}`} />
      </div>
    );
  } else if (value.length > maxLength) {
    errors[field] = (
      <div id="max-length">
        <FormattedMessage id={`app.field.max.length.${field}`} values={{ maxLength }} />
      </div>
    );
  } else if (isFieldUnique(values, props) === false) {
    errors[field] = (
      <div id="already-used">
        <FormattedMessage id={`app.field.already.used.${field}`} />
      </div>
    );
  }

  return errors;
};

// eslint-disable-next-line react/prefer-stateless-function
class SaveReportForm extends Component {
  render() {
    const {
      onCloseModal,
      submitting,
      valid,
      errorMessage,
      pristine,
      handleSubmit,
    } = this.props;

    return (<SaveSelectionForm
      onCloseModal={onCloseModal}
      submitting={submitting}
      valid={valid}
      errorMessage={errorMessage}
      pristine={pristine}
      handleSubmit={handleSubmit}
      field={field}
    />);
  }
}

SaveReportForm.propTypes = {
  ...reduxFormPropTypes,
  onCloseModal: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

SaveReportForm.defaultProps = {
  errorMessage: '',
};

export default reduxForm({
  form: 'saveSelection',
  validate,
})(SaveReportForm);
